import type {
  IntegrationProfilePopulationSetting,
  IntegrationProfileStandardPopulationSetting,
  IntegrationProfileType,
  MinimalIntegrationProfile,
} from '@/types/integration_profiles';
import { STANDARD_POPULATIONS } from '@/types/populations';

const STANDARD_POPULATION_SETTING_TYPES = [
  'custom',
  ...STANDARD_POPULATIONS,
] as const satisfies readonly IntegrationProfileStandardPopulationSetting['standard_type'][];

export function fillStandardPopulationSettings(
  existingSettings: IntegrationProfileStandardPopulationSetting[] = [],
): IntegrationProfileStandardPopulationSetting[] {
  const includedByType = new Map(
    existingSettings.map((setting) => [
      setting.standard_type,
      setting.is_included,
    ]),
  );

  return STANDARD_POPULATION_SETTING_TYPES.map((standardType) => ({
    standard_type: standardType,
    is_included: includedByType.get(standardType) ?? false,
  }));
}

type WithConfigType<Setting> = Setting & {
  config_type?: IntegrationProfileType;
};

type ConfigTypedIntegrationProfile = Omit<
  MinimalIntegrationProfile,
  'population_settings' | 'standard_population_settings'
> & {
  population_settings: WithConfigType<IntegrationProfilePopulationSetting>[];
  standard_population_settings: WithConfigType<IntegrationProfileStandardPopulationSetting>[];
};

function toPopulationSetting({
  population_id,
  is_partner_population,
  is_included,
}: IntegrationProfilePopulationSetting): IntegrationProfilePopulationSetting {
  return { population_id, is_partner_population, is_included };
}

function toStandardPopulationSetting({
  standard_type,
  is_included,
}: IntegrationProfileStandardPopulationSetting): IntegrationProfileStandardPopulationSetting {
  return { standard_type, is_included };
}

export function removeConfigType(
  settings: ConfigTypedIntegrationProfile,
): MinimalIntegrationProfile {
  return {
    ...settings,
    population_settings: settings.population_settings.map(toPopulationSetting),
    standard_population_settings: settings.standard_population_settings.map(
      toStandardPopulationSetting,
    ),
  };
}
